import React, { useState } from "react";
import { withLocalize } from "react-localize-redux";
import footer from "../../translations/footer.json";
import { Translate } from "react-localize-redux";
import { langs } from "../../translations/translateJsonFile";
import "../../styles/footer.scss";
import "../../styles/app.scss";
import "../../styles/color.scss";
import Logo from "../../assets/images/logos/verified-logo.png";
import BySertifierLogo from "../../assets/images/logos/by-sertifier-logo.png";
import { useDetectClickOutside } from "react-detect-click-outside";
import Dropdown from "react-bootstrap/Dropdown";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";
import { Link } from "react-router-dom/cjs/react-router-dom";
import styled from "styled-components";
import { ReactComponent as LanguageIcon } from "../../assets/common/language.svg";
import { ReactComponent as InstagramLogo } from "../../assets/socials/instagram-black.svg";
import { ReactComponent as FacebookLogo } from "../../assets/socials/facebook-black.svg";
import { ReactComponent as TwitterLogo } from "../../assets/socials/twitter-black.svg";
import { ReactComponent as LinkedinLogo } from "../../assets/socials/linkedin-black.svg";
import ConditionalWrapper from "./ConditionalWrapper";
import { useAppSelector } from "../../store/hooks";
import { selectUser } from "../../store/features/user";
import {
	configFallback,
	getMasterConfig,
} from "wallet-elementkit/dist/constants/master";
import { UrlUtils } from "wallet-elementkit/dist/services";
import { logActionEvent } from "wallet-elementkit/dist/services/backend/Events";
import { EventActions } from "wallet-elementkit/dist/constants/constants";
import { Subdomains } from "wallet-elementkit/dist/constants";

const StyledFooter = styled.div`
	${(props) => `
		.customizable-text {
			color: ${props.textColor} !important;
		}
		.policy-text {
			color: ${props.textColor}8C !important;
		}
		.social-icon {
			fill: ${props.textColor} !important;
		}

		.dropdown-menu.show {
			border: 1px solid ${props.primaryColor} !important;
		}
  			`};
`;

const Footer = (props) => {
	props.addTranslation(footer);
	const userMeta = useAppSelector(selectUser);
	const { certificateLanguages, certificateLanguageCodes } = langs;
	const [langClicked, setLangClicked] = useState(false);

	const config = getMasterConfig();
	const disableLangSelection = config.subDomain === Subdomains.bitdefender;
	const disablePoweredBySertifierText =
		config.subDomain === Subdomains.letsshineksa;
	const handleLangClick = () => {
		setLangClicked((prevState) => !prevState);
	};
	const langMenuRef = useDetectClickOutside({
		onTriggered: langClicked ? handleLangClick : null,
	});
	const changeLang = (code) => {
		let arr = window.location.href.split("/");
		arr[3] = code;
		let adress = arr.reduce((a, b) => a + "/" + b);
		// setActiveLanguage(code);
		window.location.replace(adress);
	};

	const socialActionType = (social) => {
		return social.type === "instagram"
			? EventActions.InstagramTrafficGain
			: social.type === "facebook"
			? EventActions.FacebookTrafficGain
			: social.type === "twitter"
			? EventActions.TwitterTrafficGain
			: social.type === "linkedin"
			? EventActions.LinkedinTrafficGain
			: null;
	};
	return (
		<StyledFooter
			textColor={props.config.footerTextColor}
			primaryColor={props.config.primaryColor}
		>
			<div
				className="footer-main-out"
				style={{
					backgroundColor: props.config.footerBackgroundColor,
				}}
			>
				<div className="flex-column footer-main">
					<div className="footer-top">
						{props.config.logoLink === configFallback.logoLink ? (
							<div className="flex-row ai-fe">
								<ConditionalWrapper
									condition={true}
									wrapper={(children) =>
										userMeta.logged ? (
											<Link
												to={
													userMeta.logged
														? props.activeLanguage
															? `/${props.activeLanguage.code}/profile/${userMeta.user.username}/`
															: `/en/profile/${userMeta.user.username}/`
														: props.activeLanguage
														? `/${props.activeLanguage.code}/`
														: "/en/"
												}
											>
												{children}
											</Link>
										) : (
											<a
												href={
													props.config.logoRedirectUrl.includes("http")
														? props.config.logoRedirectUrl
														: `http://${props.config.logoRedirectUrl}`
												}
												target="_blank"
												rel="noreferrer"
											>
												{children}
											</a>
										)
									}
									children={
										<img
											alt="Verified by Sertifier Logo"
											src={Logo}
											className="verified-logo"
											height={props.isMobile ? 26.261 : 55}
										/>
									}
								/>
								<a
									href="https://sertifier.com"
									target="_blank"
									rel="noreferrer"
									style={{
										marginLeft: props.isMobile ? "7px" : "14.5px",
									}}
									className="by-sertifier-wrapper"
								>
									<img
										src={BySertifierLogo}
										alt="By Sertifier Logo"
										className="by-sertifier-logo"
										height={props.isMobile ? 15.631 : 38}
									/>
								</a>
							</div>
						) : (
							<a
								href={
									props.config.logoRedirectUrl.includes("http")
										? props.config.logoRedirectUrl
										: `http://${props.config.logoRedirectUrl}`
								}
								target="_blank"
								rel="noreferrer"
							>
								<img
									alt="Verified"
									src={props.config.logoLink}
									className="org-logo"
									style={{ cursor: "pointer", marginRight: "auto" }}
								/>
							</a>
						)}
						{props.config.footerMenu?.length ? (
							<div className="menu-items">
								{props.config.footerMenu.map((item) => (
									<a
										href={item.link}
										target="_blank"
										rel="noreferrer"
										className="single-menu-item customizable-text"
									>
										{item.text}
									</a>
								))}
							</div>
						) : null}
						{props.config.socials.length ? (
							<div className="flex-row socials">
								{props.config.socials.map((social) => (
									<a
										key={social.link}
										href={UrlUtils.toAbsoluteUrl(social.link)}
										target="_blank"
										rel="noreferrer noopener"
										onClick={(e) => {
											e.preventDefault();
											// log action event
											logActionEvent(
												"", // Empty credential_no
												socialActionType(social),
												props.organizationId,
												""
											);
											// if social link is not absolute, open in new tab
											window.open(
												UrlUtils.toAbsoluteUrl(social.link),
												"_blank"
											);
										}}
									>
										{social.type === "instagram" ? (
											<InstagramLogo className="social-icon" />
										) : null}
										{social.type === "facebook" ? (
											<FacebookLogo className="social-icon" />
										) : null}
										{social.type === "twitter" ? (
											<TwitterLogo className="social-icon" />
										) : null}
										{social.type === "linkedin" ? (
											<LinkedinLogo className="social-icon" />
										) : null}
									</a>
								))}
							</div>
						) : null}
					</div>
					<div className="hl"></div>
					<div className="footer-bottom">
						{config.subDomain !== Subdomains.bitdefender && (
							<div className="left">
								{!disablePoweredBySertifierText && (
									<a
										className="s5 boldish customizable-text"
										href={process.env.REACT_APP_FOOTER_POWERED_BY_REDIRECT_LINK}
										target="_blank"
									>
										© {process.env.REACT_APP_FOOTER_POWERED_BY_TITLE}
									</a>
								)}
								<a
									className="s5 policy-text"
									href={process.env.REACT_APP_PRIVACY_POLICY_LINK}
									target="_blank"
								>
									<Translate id="privacyPolicy" />
								</a>
								<a
									className="s5 policy-text"
									href={process.env.REACT_APP_TERMS_LINK}
									target="_blank"
								>
									<Translate id="termsOfUse" />
								</a>
							</div>
						)}
						{!disableLangSelection && (
							<Dropdown
								id="dropdown-basic-button"
								onSelect={(langCode) => {
									changeLang(langCode);
								}}
							>
								<Dropdown.Toggle>
									<BaseButton
										type="secondary"
										size="small"
										loading={false}
										backgroundColor={props.config.primaryColor}
									>
										<LanguageIcon className="lang-icon customizable-icon" />
										<span>
											{props.activeLanguage ? props.activeLanguage.name : ""}
										</span>
									</BaseButton>
								</Dropdown.Toggle>
								<Dropdown.Menu>
									{certificateLanguages.map((language) => (
										<Dropdown.Item eventKey={language.code} key={language.code}>
											{language.name}
										</Dropdown.Item>
									))}
								</Dropdown.Menu>
							</Dropdown>
						)}
					</div>
				</div>
			</div>
		</StyledFooter>
	);
};

export default withLocalize(Footer);
